<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <a
    class="access-info-btn"
    :class="{isProminent}"
    href="#"
    @click.prevent="$emit('click')"
  >{{ label }}</a>
</template>

<script setup>
// isProminent: the orange call-to-action look (e.g. "How do I unlock all videos?"); otherwise a
// quiet dark bar (e.g. "Return to VIZBI Video Library"), as VideoAccessActionButton
defineProps({label: {type: String, required: true}, isProminent: {type: Boolean, default: false}});
defineEmits(["click"]);
</script>

<style scoped>
.access-info-btn {
  display: block;
  width: 100%;
  box-sizing: border-box;
  background: #252525;
  border: 1px solid #3a3a3a;
  color: var(--orange-on-dark);
  text-align: center;
  padding: 0.5rem 1rem;
  font: inherit;
  font-size: 1rem; /* as the buttons under it: a <button> otherwise takes the browser's small size */
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}
.access-info-btn.isProminent {
  background: var(--orange-on-dark);
  color: #111111;
  border: none;
  border-radius: 5px;
  font-weight: 700;
}
.access-info-btn.isProminent:hover {
  background: var(--orange-on-dark);
  filter: brightness(1.1);
}
.access-info-btn:hover {
  background: #2e2e2e;
  border-color: #4a4a4a;
}
/* dark mode, as VideoAccessActionButton.vue's: lighter, with a clear edge */
.darkMode .access-info-btn:not(.isProminent) {
  background: #36383c;
  border-color: #64676c;
}
/* wider screens: a touch larger */
@media (min-width: 700px) {
  .access-info-btn {
    font-size: 1.125rem;
  }
}
</style>
